export const loadIndianaAverages = async () => {
  try {
    const response = await fetch('/indiana_averages.json');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('failed to load indiana averages:', error);
    return null;
  }
};

